export const petTagReviewData = {
  one: [
    {
      name: "Sadia Khatun",
      location: "Sylhet",
      org: "twitter",
      reviewIconType: "star",
      content:
        "We got our cat back within hours thanks to the AmarPet tag. Every pet owner should have one of these.",
    },
    {
      name: "Zakia Sultana",
      location: "Gazipur",
      org: "trustpilot",
      reviewIconType: "trustpilot",
      content:
        "This product is fantastic! My cat wandered off, and we found her quickly thanks to the AmarPet tag.",
    },

    {
      name: "Mizanur Rahman",
      location: "Dhaka",
      org: "chaldal",
      reviewIconType: "love",
      content:
        "When my dog, Bruno, ran away, our entire family was devastated. We spent hours searching the neighborhood, calling out his name, but there was no sign of him. The next morning, I received a call from a kind woman who had found Bruno wandering around her garden. She had scanned the AmarPet tag, and all my contact details appeared instantly. Within half an hour, Bruno was back home, wagging his tail as if nothing had happened. This tag is truly a lifesaver!",
    },

    {
      name: "Shahana Khan",
      location: "Sylhet",
      org: "facebook",
      reviewIconType: "star",
      content:
        "The AmarPet tag is worth every penny. My kitten was back within hours of getting lost.",
    },

    {
      name: "Farhana Yasmin",
      location: "Sylhet",
      org: "daraz",
      reviewIconType: "love",
      content:
        "I love this product! It helped us find our lost pet faster than I could have imagined.",
    },

    {
      name: "Mrinhas Sarkar",
      location: "Rajshahi",
      org: "twitter",
      reviewIconType: "star",
      content:
        "I can&lt;t be happier, my dear friend, so close to my heart, was found. Thank you, AmarPet!",
    },

    {
      name: "Sarwar Hossain",
      location: "Dhaka",
      org: "twitter",
      reviewIconType: "star",
      content:
        "The AmarPet Smart Tag saved my cat, Mimi! She wandered off one evening, and thanks to the QR code, a kind neighbor found her and brought her back. Couldn&lt;t be more grateful!",
    },

    {
      name: "Munira Rahman",
      location: "Barishal",
      org: "twitter",
      reviewIconType: "star",
      content:
        "We found our lost kitten within hours, thanks to AmarPet&lt;s innovative product.",
    },

    {
      name: "Tahmina Rahman",
      location: "Sylhet",
      org: "daraz",
      reviewIconType: "love",
      content:
        "We found our lost kitten within hours, thanks to AmarPet&lt;s innovative product.",
    },

    {
      name: "Rehana Parvin",
      location: "Sylhet",
      org: "facebook",
      reviewIconType: "star",
      content:
        "Our pet rabbit went missing, and I was so worried. Thanks to the AmarPet tag, we found her quickly.",
    },
  ],
  two: [
    {
      name: "Tahmina Rahman",
      location: "Sylhet",
      org: "daraz",
      reviewIconType: "love",
      content:
        "We got our cat back within hours thanks to the AmarPet tag. Every pet owner should have one of these.",
    },

    {
      name: "Nusrat Jahan Asha",
      location: "Chittagong",
      org: "facebook",
      reviewIconType: "star",
      content:
        "I got my cat back, thanks to AmarPet and its brilliant idea. I hope every pet owner will get help from this product.",
    },

    {
      name: "Arman Hossain",
      location: "Gazipur",
      org: "chaldal",
      reviewIconType: "love",
      content:
        "My pet parrot flew away, and I thought I’d never see him again. But thanks to AmarPet, we’re together again.",
    },

    {
      name: "Mohammad Rahman",
      location: "Dhaka",
      org: "twitter",
      reviewIconType: "star",
      content:
        "Our dog, Rocky, has a habit of escaping through the smallest gaps in the fence. After the third time, we decided to get the AmarPet Smart Tag. I’m so glad we did. Just last week, Rocky slipped out again, but this time, a neighbor down the street found him. Thanks to the tag, she was able to call us immediately. What used to be a stressful situation turned into a quick reunion.",
    },

    {
      name: "Faruk Ahmed",
      location: "Chittagong",
      org: "facebook",
      reviewIconType: "star",
      content:
        "AmarPet has really impressed me. I was reunited with my lost dog faster than I thought possible.",
    },

    {
      name: "Nadia Islam",
      location: "Comilla",
      org: "daraz",
      reviewIconType: "love",
      content:
        "I have to say, AmarPet has exceeded my expectations. I’ve had cats for years, and one of my biggest fears has always been losing them. My cat, Misty, got out one evening and didn’t come back. I was panicking when I realized I couldn’t find her. Thankfully, I had just put the AmarPet tag on her a week prior. A kind stranger found her and scanned the tag, and within minutes, I received a notification with their contact details. Misty was home by the end of the day, safe and sound. I’m so thankful for this product.",
    },

    {
      name: "Tanveer Ahmed",
      location: "Dhaka",
      org: "trustpilot",
      reviewIconType: "trustpilot",
      content:
        "The peace of mind AmarPet has provided is priceless. My dog was lost, but within hours, he was back.",
    },

    {
      name: "Tanveer Ahmed",
      location: "Dhaka",
      org: "trustpilot",
      reviewIconType: "trustpilot",
      content:
        "The peace of mind AmarPet has provided is priceless. My dog was lost, but within hours, he was back.",
    },

    {
      name: "Tayef Ahmed",
      location: "Sylhet",
      org: "facebook",
      reviewIconType: "star",
      content:
        "I got my lost dog back, thanks to the community of AmarPet. They really care for every pet.",
    },

    {
      name: "Hasanuzzaman",
      location: "Comilla",
      org: "chaldal",
      reviewIconType: "love",
      content:
        "AmarPet has made finding my lost dog so easy. I’m so thankful for this product.",
    },
  ],

  three: [
    {
      name: "Sharmin Akhter",
      location: "Dhaka",
      org: "twitter",
      reviewIconType: "star",
      content:
        "I was so scared when our dog ran away, but AmarPet brought him back to us safely.",
    },

    {
      name: "Tariqul Islam",
      location: "Dhaka",
      org: "facebook",
      reviewIconType: "star",
      content:
        "My dog got lost during a walk, but thanks to AmarPet, he was found and returned safely.",
    },

    {
      name: "Munira Rahman",
      location: "Barishal",
      org: "daraz",
      reviewIconType: "love",
      content:
        "We found our lost kitten within hours, thanks to AmarPet’s innovative product.",
    },

    {
      name: "Mahfuja Hoque",
      location: "Khulna",
      org: "trustpilot",
      reviewIconType: "trustpilot",
      content:
        "A wonderful service has taken away all my worries. My cat, Ginger, went missing for hours, and within no time, she was back thanks to AmarPet.",
    },

    {
      name: "Kamrul Islam",
      location: "Dhaka",
      org: "twitter",
      reviewIconType: "star",
      content:
        "AmarPet’s smart tag is a brilliant invention. I found my dog within hours after he got lost.",
    },

    {
      name: "Afroza Begum",
      location: "Rajshahi",
      org: "facebook",
      reviewIconType: "star",
      content:
        "My cat is safe, thanks to AmarPet. I was worried when she didn’t come home, but the tag brought her back.",
    },

    {
      name: "Rakibul Islam",
      location: "Chittagong",
      org: "chaldal",
      reviewIconType: "star",
      content:
        "My experience with AmarPet has been nothing short of amazing. My dog, Max, is quite the explorer, and one day he decided to venture a little too far from home. I was frantic when I realized he was missing. The AmarPet tag made all the difference. A good Samaritan found Max and scanned the tag, which provided them with my contact information. Within an hour, I got a call, and I was able to bring Max back home. The whole process was so smooth and efficient.",
    },

    {
      name: "Ashfaque Ahmed",
      location: "Dhaka",
      org: "trustpilot",
      reviewIconType: "trustpilot",
      content:
        "The AmarPet tag is amazing. My dog, who often escapes the yard, was back in no time thanks to this tag.",
    },

    {
      name: "Mehdi Hassan",
      location: "Khulna",
      org: "daraz",
      reviewIconType: "love",
      content:
        "This is such a useful tool. We found our cat in no time. AmarPet is a must for every pet owner.",
    },

    {
      name: "Afroza Begum",
      location: "Rajshahi",
      org: "facebook",
      reviewIconType: "star",
      content:
        "My cat is safe, thanks to AmarPet. I was worried when she didn’t come home, but the tag brought her back.",
    },
  ],
  four: [
    {
      name: "Tushar Ahmed",
      location: "Dhaka",
      org: "twitter",
      reviewIconType: "star",
      content:
        "My pet dog ran off during a storm, and I thought I had lost her forever. Thanks to AmarPet, she was found within a day.",
    },

    {
      name: "Rubina Akbar",
      location: "Dhaka",
      org: "chaldal",
      reviewIconType: "star",
      content:
        "This product is a lifesaver! It’s amazing how quickly we found our cat after she went missing. AmarPet, you’re doing great work.",
    },

    {
      name: "Ashraf Khan",
      location: "Gazipur",
      org: "facebook",
      reviewIconType: "star",
      content:
        "A simple scan of the tag, and my dog was back home. What an incredible invention.",
    },

    {
      name: "Maria Noor",
      location: "Chittagong",
      org: "daraz",
      reviewIconType: "love",
      content:
        "I was really worried when my cat didn’t come home. AmarPet helped me find her fast!",
    },

    {
      name: "Sharifa Khatun",
      location: "Sylhet",
      org: "twitter",
      reviewIconType: "star",
      content:
        "I recommend the AmarPet tag to every pet owner. It brought my lost cat back home quickly.",
    },

    {
      name: "Jamil Ahmed",
      location: "Chittagong",
      org: "facebook",
      reviewIconType: "star",
      content:
        "This smart tag is incredibly effective. I found my dog thanks to a good Samaritan who scanned the tag.",
    },

    {
      name: "Raisa Tabassum",
      location: "Comilla",
      org: "chaldal",
      reviewIconType: "star",
      content:
        "AmarPet’s tag worked perfectly! My dog was back home within hours of getting lost. Thank you!",
    },

    {
      name: "Mehdi Hassan",
      location: "Khulna",
      org: "daraz",
      reviewIconType: "love",
      content:
        "This is such a useful tool. We found our cat in no time. AmarPet is a must for every pet owner.",
    },

    {
      name: "Sadia Afrin",
      location: "Dhaka",
      org: "facebook",
      reviewIconType: "star",
      content:
        "My cat, Simba, is always curious about the outdoors. One day, he managed to slip out and went missing for hours. I was so worried and searched everywhere. Then, I remembered the AmarPet Smart Tag I had recently attached to his collar. A quick check on my phone showed a notification from someone who had found Simba. They scanned the tag and contacted me immediately. I rushed over and brought him back home safely. This tag is a lifesaver, and I can’t thank AmarPet enough.",
    },

    {
      name: "Sabina Yasmin",
      location: "Barishal",
      org: "trustpilot",
      reviewIconType: "trustpilot",
      content:
        "My experience with AmarPet has been outstanding. My cat, Luna, has a habit of wandering off, and I used to worry endlessly about her getting lost. Since I got the AmarPet tag, I feel so much more at ease. Recently, Luna went missing, and I was heartbroken. But thanks to the tag, someone found her and contacted me right away. Luna was back home within hours.",
    },
  ],
};
